import { StringConstants } from "./StringConstants";

class NotificationConstants extends StringConstants {
  GENERIC_ERROR = "Something went wrong! Please try again.";
  VALIDDETAILS = "Please fill valid details.";
  LOGGEDOUT = "You're logged out. Please login to continue.";
  LOGGEDIN = "Login Successful.";
  LOGIN_ERROR = "Please enter valid email id and password";
  STEPPEERROR = "Please Register  user";
}

let notifiers = new NotificationConstants();
export default notifiers;
